<template>
    <div class="pagination">
        <button
            class="pagination__prev"
            :disabled="currentPage === 1"
            :class="{disabled: currentPage === 1}"
            @click="handlePageChange(currentPage - 1)"
        >Назад</button>
        <button
            v-for="(item, index) in pagesArray"
            :key="index"
            :class="{'active' :  item === currentPage}"
            class="pagination__item"
            @click="handlePageChange(item)"
        >{{item}}</button>
        <button
            class="pagination__next"
            :class="{disabled: currentPage === pagesCount}"
            :disabled="currentPage === pagesCount"
            @click="handlePageChange(currentPage + 1)"
        >Вперед</button>
    </div>
</template>

<script>
export default {
    name: "PaginationList",
    emits: ['changePage'],
    props: {
        count: {
            type: Number,
            required: true,
        },
        limit: {
            type: Number,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        }
    },
    computed: {
        pagesCount() {
            const res = this.count % this.limit;
            return res === 0 ?  this.count / this.limit :  Math.floor(this.count / this.limit) + 1;
        },
        pagesArray() {
            const res = [];
            for (let i = 1; i <= this.pagesCount; i++) {
                res.push(i)
            }
            return res;
        },

    },
    methods: {
        handlePageChange(newPage) {
            if (newPage >= 1 && newPage <= this.pagesCount)  this.$emit('changePage', newPage)
        }
    }

}
</script>

